import React, { useState } from 'react';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton,
  useTheme,
  useMediaQuery,
  Drawer,
  styled,
  Box
} from '@mui/material';
import { Link } from 'react-router-dom';
import {
  Close,
  Menu as MenuIcon,
  Map
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)', // Changé de borderRight à borderLeft
  backgroundColor: '#fff',
  marginLeft: 'auto', // Pour pousser le menu vers la droite
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0, // Positionné à droite
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)', // Déplacement vers la droite
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start', // Changé de flex-end à flex-start
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const SideMenuBujumbura = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Définition des éléments de menu avec icône Map pour toutes les provinces
  const menuItems = [
    { text: 'BUBANZA', icon: <Map color="primary" />, to: '/populationDataPageBujumburaBubanza' },
    { text: 'CIBITOKE', icon: <Map color="primary" />,  to: '/populationDataPageBujumburaCibitoke' },
    { text: 'ISARE', icon: <Map color="primary" />, to: '/populationDataPageBujumburaIsare' },
    { text: 'MPANDA', icon: <Map color="primary" />, to: '/populationDataPageBujumburaMpanda' },
    { text: 'MUGINA', icon: <Map color="primary" />, to: '/PopulationDataPageBujumburaMugina' },
    { text: 'BUKINANYANA', icon: <Map color="primary" />, to: '/populationDataPageBujumburaBukinanyana' },
    { text: 'MUGERE', icon: <Map color="primary" />, to: '/populationDataPageBujumburaMugere' },
    { text: 'MUHUTA', icon: <Map color="primary" />, to: '/populationDataPageBujumburaMuhuta' },
    { text: 'MUKAZA', icon: <Map color="primary" />, to: '/populationDataPageBujumburaMukaza' },
    { text: 'NTAHANGWA', icon: <Map color="primary" />, to: '/populationDataPageBujumburaNtahangwa' },
    { text: 'RWIBAGA', icon: <Map color="primary" />, to: '/populationDataPageBujumburaRwibaga' }
  ];

  // Composant du menu latéral
  const drawerContent = (  
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
              sx={{
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                }
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText 
                primary={item.text} 
                primaryTypographyProps={{
                  fontSize: '14px',
                  fontWeight: 'medium'
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <>
      {/* Bouton menu pour mobile */}
      {isMobile && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ 
              color: '#E30613', 
              borderColor: '#E30613',
              border: '1px solid',
              mr: 1,
              '&:hover': {
                backgroundColor: 'rgba(227, 6, 19, 0.1)'
              }
            }}
          >
            <MenuIcon />
          </IconButton>
        </Box>
      )}
      
      {/* Menu pour desktop */}
      {!isMobile && (
        <DrawerWrapper>
          {drawerContent}
        </DrawerWrapper>
      )}
      
      {/* Drawer pour mobile */}
      <Drawer
        variant="temporary"
        anchor="right" // Changé de gauche à droite
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { 
            boxSizing: 'border-box', 
            width: drawerWidth,
          },
        }}
      >
        {drawerContent}
      </Drawer>
    </>
  );
};

export default SideMenuBujumbura;